<template>
    <Section :width="sliceWidth" class="latest-reviews">
        <div 
            v-if="$validateText(slice.primary.text)"
            class="rich-text primary-text"
            v-html="$prismic.asHtml(slice.primary.text)"
        />
        <div 
            class="review-wrapper" 
            :class="{'width-small': sliceWidth === 'sm'}"
        >
            <review 
                v-for="review in latestReviews" 
                :key="`${review.card_id}-${review.posted_at}`"
                :review="review"    
            />
        </div>
    </Section>
</template>

<script>
import Review from './Review.vue';
export default {
    components: {
        Review
    },
    props: {
        slice: {
            type: Object,
            required: true
        }
    },
    computed: {
        latestReviews() {
            return this.$store.state.latestCardReviews;
        },
        sliceWidth() {
            return this.slice.primary.slice_width || 'md';
        }
    }
};
</script>

<style lang="scss" scoped>
.latest-reviews {
    .primary-text {
        @include spacing(margin, 4, bottom);
    }
    .review-wrapper {
        display: grid;
        grid-template-columns: repeat(1, 1fr);
        gap: 1rem;
        @include device(pad) {
            grid-template-columns: repeat(2, 1fr);
        }

        &:not(.width-small) {
            @include device(desktop) {
                grid-template-columns: repeat(3, 1fr);
            }
        }
    }
}
</style>